<template>
  <div>
   <b-nav-item-dropdown right no-caret class="header-requests">
      <template v-if="Requests.length > 0" slot="button-content">
        <i class="icon-bell text-white"></i>
        <span class="badge badge-pill badge-danger">{{Requests.length}}</span>
      </template>
      <template v-else slot="button-content">
        <i class="icon-bell text-muted"></i>
        <span class="badge badge-pill badge-secondary">0</span>
      </template>
      <b-dropdown-header v-if="Requests.length > 0" tag="div" class="text-center">
        <strong>Requests ({{Requests.length}})</strong>
      </b-dropdown-header>
      <b-dropdown-item v-else disabled class="empty-state">
        <i class="fa fa-inbox text-muted"></i> No pending requests
      </b-dropdown-item>
     <b-dropdown-item v-for="item in Requests" v-if="Requests.length > 0" @click="createModal(item)" :key="item.id" class="request-item">
      <i class="fa fa-flash text-warning"></i>
    <span v-if="PokemonAdd.eq(item.type)">{{item.username}} requested a Pokemon spawn</span>
    <span v-if="UserNameChange.eq(item.type)">{{item.username}} requested a name change to {{item.data}} </span>

     </b-dropdown-item>
    </b-nav-item-dropdown>

    <b-modal size="md" v-model="modal" @ok="modal = false">
      <template v-if="modalRequest && PokemonAdd.eq(modalRequest.type)">
        <div v-if="modalRequest" slot="modal-title" class="w-100">
          {{modalRequest.username}}'s Pokemon Request
          <small v-for="serv in modalRequest.data.servers" :class="'badge-' + serv" class="badge text-capitalize">
            {{serv}}</small>
        </div>
        <span v-if="modalRequest">
        <img class="img-thumbnail float-md-right" :src="getMonsterImage(modalRequest.data.monster_id, modalRequest.data.shiny)"/>
        <strong>{{findMonster(modalRequest.data)}}</strong> <small>{{modalRequest.data.shiny ? '(Shiny)' : ''}}  LvL {{modalRequest.data.level}}</small><br>
        <small>
          <strong>IVs:</strong> {{modalRequest.data.ivs ? modalRequest.data.ivs.join(', ') : 'N/A'}}<br>
          <strong>Moves:</strong> {{joinMoves(modalRequest.data.moves)}}
        </small>
      </span>
      </template>
      <template v-if="modalRequest && UserNameChange.eq(modalRequest.type)">
        <div slot="modal-title" class="w-100">
          {{modalRequest.username}}'s Name Change Request
        </div>
        <span>
          {{modalRequest.username}} requested a name change to <strong>{{modalRequest.data}}</strong>
        </span>
      </template>

      <div slot="modal-footer" class="w-100">
        <b-button variant="danger" @click="deny(modalRequest.id)"><i class="fa fa-close"></i> Decline</b-button>

        <b-button variant="success" @click="accept(modalRequest.id)" class="float-right"><i class="fa fa-check"></i> Accept</b-button>

      </div>

    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Monsters from './../../../views/pokemon/_monsters.js'
  import Moves from './../../../views/pokemon/_moves.js'
  import Natures from './../../../views/pokemon/_natures'
  import VueNotifications from 'vue-notifications'

  export default {
    name: 'Requests',
    computed: {
      ...mapGetters(['Requests', 'RequestError'])
    },
    data () {
      return {
        modal: false,
        title: '',
        modalID: null,
        monsters: Monsters,
        natures: Natures,
        moves: Moves,
        modalRequest: null
      }
    },
    methods: {
      getMonsterImage (pid, shiny) {
        if (!pid) return ''
        const folder = shiny ? 'shiny/' : ''
        return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${folder}${pid}.png`
      },
      createModal (request) {
        this.modal = true
        this.modalRequest = request
      },
      findMonster (data) {
        const monster = Monsters.find(monster => monster.ID === data.monster_id)
        return monster ? monster.Name : 'Unknown Pokemon (ID: ' + data.monster_id + ')'
      },
      accept (id) {
        this.emit('request', {'id': id, 'type': 1})
        this.modal = false
      },
      deny (id) {
        this.emit('request', {'id': id, 'type': 2})
        this.modal = false
      },
      joinMoves (moves) {
        if (!moves) return ''
        return moves.map(mid => {
          const move = Moves.find(m => m.ID === mid)
          return move ? move.Name : 'Unknown Move (' + mid + ')'
        }).join(', ')
      }
    },
    notifications: {
      ChangeSuccessful: {
        type: VueNotifications.types.success,
        title: 'Request successful!',
        message: 'Request was successful!'
      },
      UserOnline: {
        type: VueNotifications.types.error,
        title: 'Request failed!',
        message: 'Request failed, this user is currently online.'
      },
      UserTaken: {
        type: VueNotifications.types.error,
        title: 'Request failed!',
        message: 'Request failed, this name is alread ytaken.'
      }
    },
    watch: {
      RequestError: function (e) {
        switch (e.error) {
          case 1:
            this.modal = false
            this.ChangeSuccessful()
            break
          case 2:
            this.modal = false
            this.UserOnline()
            break
          case 3:
            this.modal = false
            this.UserTaken()
            break
        }
      }
    }
  }
</script>

<style scoped>
.header-requests /deep/ .dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 16px;
  transition: background-color 0.15s ease;
}
.header-requests /deep/ .nav-link {
  padding-left: 6px;
  padding-right: 6px;
}
.header-requests /deep/ .dropdown-toggle:hover {
  background-color: rgba(255, 255, 255, 0.06);
}
.header-requests /deep/ .dropdown-menu {
  min-width: 260px;
}
.header-requests /deep/ .badge {
  font-size: 0.7rem;
  letter-spacing: 0.02em;
}
.request-item {
  white-space: normal;
  line-height: 1.25;
}
.empty-state {
  color: #8f9ba6;
}
</style>
